"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const utils_1 = require("../../utils/utils");
const authSlice_1 = require("./authSlice");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const text_1 = __importStar(require("../../components/text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const analytics_1 = require("../../utils/analytics/analytics");
const NowNowInvitation = ({ route }) => {
    const { params } = route;
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { validCode } = (0, store_1.useAppSelector)((state) => {
        return {
            validCode: state.auth.valid_code,
        };
    });
    const [validKey, setValidKey] = (0, react_1.useState)(false);
    // const [keyError, setValidKeyError] = useState<ErrorType>();
    const [password1, setPassword1] = (0, react_1.useState)('');
    const [password2, setPassword2] = (0, react_1.useState)('');
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const invitation = async () => {
        setIsLoading(true);
        const invitationKey = params ? params.invitation_key : '';
        const result = await dispatch((0, authSlice_1.getNowNowPassword)({ invitationKey }));
        logEventWithExtraProperties('api_call', {
            name: 'get_now_now_password',
            status: 'submitted',
            location: 'screen_NowNowInvitation',
        });
        if (!(0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'get_now_now_password',
                status: 'success',
                location: 'screen_NowNowInvitation',
            });
            // setValidKeyError({...result.payload});
            setErrors(result.payload);
        }
        logEventWithExtraProperties('api_call', {
            name: 'get_now_now_password',
            status: 'fail',
            location: 'screen_NowNowInvitation',
        });
        setIsLoading(false);
    };
    // FETCH DATA
    (0, react_1.useEffect)(() => {
        dispatch((0, authSlice_1.resetNowNowStore)());
        invitation();
    }, []);
    // UPDATE FIELDS AFTER COME DATA FROM SERVER
    (0, react_1.useEffect)(() => {
        setValidKey(validCode);
    }, [validCode]);
    const submitForm = async () => {
        setIsLoading(true);
        const invitationKey = params ? params.invitation_key : '';
        const payload = {
            password_1: password1.toString(),
            password_2: password2.toString(),
            invitationKey,
        };
        const result = await dispatch((0, authSlice_1.createNowNowPassword)(payload));
        if ((0, toolkit_1.isRejectedWithValue)(result) && result.payload) {
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    return (react_1.default.createElement(navContainer_1.default, { titleText: "Invitation registration", isLoading: isLoading }, validKey ? (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, placeholder: "Password", setValue: setPassword1, error: (0, utils_1.getError)('password_1', errors), value: password1 }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, placeholder: "Repeat password", setValue: setPassword2, error: (0, utils_1.getError)('password_2', errors), value: password2 }),
        react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Save", onPress: submitForm, eventName: "nowNowRegister_submit" }))) : (react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_CRITICAL }, (0, utils_1.getError)('', errors) || '')))));
};
exports.default = NowNowInvitation;
